import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs'

@Injectable({
    providedIn: 'root'
  })   
export class SharedComponentService {
    private subject = new Subject<any>();

    constructor() {

    }

    sendEvent() {
        this.subject.next(true);
    }

    getEvent():Observable<any>{
        return this.subject.asObservable();
     }

}
